import {createReducer, on} from "@ngrx/store";
import {TechInventoryState} from "@tech/pages/inventory/store/tech-inventory.state";
import {TechInventoryActions} from "@tech/pages/inventory/store/tech-inventory.actions-type";
import {CoreEnvironmentService} from "@core/services/environment/core-environment.service";

function getLocalDateKey(): string {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

function getInitialInventoryState(): TechInventoryState {
  const env = CoreEnvironmentService.getEnvironment();
  return {
    page: {
      resource: {
        detail: undefined,
        isLoading: true,
        missions: {
          items: [],
          paging: {
            totalItems: 0,
            pageNumber: 0,
            pageSize: env?.apiUrl?.pageDefaultSize || 1,
            totalPages: 1
          },
          isLoading: true,
          isLoadingId: NaN,
        }
      },
      requested: {
        items: [],
        paging: {
          totalItems: 0,
          pageNumber: 0,
          pageSize: env?.apiUrl?.pageDefaultSize || 1,
          totalPages: 1
        },
        isLoading: true,
        isLoadingId: NaN,
      },
      mission: {
        isGoogleAPILoaded: false,
        items: [],
        paging: {
          totalItems: 0,
          pageNumber: 0,
          pageSize: env?.apiUrl?.pageDefaultSize || 1,
          totalPages: 1
        },
        lastScrollTop: 0,
        todayDate: getLocalDateKey(),
        todayScrollTop: 0,
        stereotypes: [],
        isLoading: true,
        isLoadingId: NaN,
        detail: undefined,
        changeState: {
          current: null,
          loading: false
        },
        report: {
          isLoading: false,
          previewCost: {},
          data: undefined,
          articlesToAdd: {
            isLoading: false,
            data: []
          },
          articleRestrictions: [],
          isSubmitLoading: false
        }
      }
    },
  }
}

export const techInventoryStore = createReducer(
  getInitialInventoryState(),
  on(TechInventoryActions.postMissionPagePaginated, (state, {pagination}) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        items: pagination.pageNumber === 1 ? [] : state.page.mission.items,
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.postMissionPagePaginatedCancel, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.postMissionPagePaginatedSuccess, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        // Important! include the current state.items and the data.items to create a new array with the
        // existing ones and the new one that is requested
        items: data.paging.pageNumber > 1 ? [...state.page.mission.items, ...data.items] : [...data.items],
        paging: data.paging,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.postMissionPagePaginatedFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.postMissionPagePaginatedRefresh, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        items: [...data.items],
        paging: data.paging,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.navigateToMissionDetail, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        isLoading: true,
      },
    },
  })),
  // detail
  on(TechInventoryActions.getMissionDetailById, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.getMissionDetailByIdSuccess, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        detail: data,
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.getMissionDetailByIdFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.getMissionDetailByIdDone, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.setMissionState, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        changeState: {
          loading: true,
        },
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.setMissionStateSuccess, (state, { missionState }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        detail: {
          ...state.page.mission.detail,
          state: missionState,
        },
        changeState: {
          current: missionState,
          loading: false,
        },
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.setMissionStateFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        changeState: {
          loading: false,
        },
      },
      isLoading: false,
    },
  })),
  on(TechInventoryActions.navigateToInventory, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.missionNavigateDone, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        isLoading: false,
      },
    },
  })),
  // requested
  on(TechInventoryActions.postMissionRequestedPagePaginated, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,

      },
      requested: {
        ...state.page.requested,
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.postMissionRequestedPagePaginatedCancel, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,

      },
      requested: {
        ...state.page.requested,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.postMissionRequestedPagePaginatedRefresh, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,

      },
      requested: {
        ...state.page.requested,
        items: [...data.items],
        paging: data.paging,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.postMissionRequestedPagePaginatedSuccess, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,

      },
      requested: {
        ...state.page.requested,
        // Important! include the current state.items and the data.items to create a new array with the
        // existing ones and the new one that is requested
        items: data.paging.pageNumber > 1 ? [...state.page.requested.items, ...data.items] : [...data.items],
        paging: data.paging,
        isLoading: false,
      },
    },
  })),
  // report
  on(TechInventoryActions.getMissionReportById, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          isModificationNeeded: false,
          isLoading: true,
        },
      },
    },
  })),
  on(TechInventoryActions.getMissionReportByIdSuccess, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          data,
          isLoading: false,
        },
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.getMissionReportByIdFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          isLoading: false,
        },
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.getMissionReportPreviewById, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          isModificationNeeded: false,
        },
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.getMissionReportPreviewByIdReset, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        detail: undefined,
        changeState: {
          current: null,
        },
        report: {
          ...state.page.mission.report,
          data: undefined,
          isModificationNeeded: false,
        },
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.missionReportDataReset, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          data: undefined,
        },
      },
    },
  })),
  on(TechInventoryActions.getMissionReportPreviewByIdSuccess, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          previewCost: data,
        },
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.getMissionReportPreviewByIdFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report
        },
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.getMissionReportArticleList, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          articlesToAdd: {
            ...state.page.mission.report.articlesToAdd,
            isLoading: true,
          },
        },
      },
    },
  })),
  on(TechInventoryActions.getMissionReportArticleListSuccess, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          articlesToAdd: {
            data,
            isLoading: false,
          },
        },
      },
    },
  })),
  on(TechInventoryActions.getMissionReportArticleListFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          articlesToAdd: {
            ...state.page.mission.report.articlesToAdd,
            isLoading: false,
          },
        },
      },
    },
  })),
  on(TechInventoryActions.submitMissionReport, (state, { formattedData }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          formattedData,
          isSubmitLoading: true,
          isLoading: true,
        },
      },
    },
  })),
  on(TechInventoryActions.submitMissionReportSuccess, (state, { response }) => {
    return {
      ...state,
      page: {
        ...state.page,
        mission: {
          ...state.page.mission,
          detail: {
            ...state.page.mission.detail,
            reportId: response.missionReportId,
          },
          report: {
            ...state.page.mission.report,
            data: undefined,
            isSubmitLoading: false,
            isLoading: false,
          },
        },
      },
    };
  }),
  on(TechInventoryActions.submitMissionReportFail, (state, { formData }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          data: formData,
          isSubmitLoading: false,
          isLoading: false,
        },
      },
    },
  })),
  on(TechInventoryActions.getResourceDetailById, (state) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.getResourceDetailByIdSuccess, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        detail: data,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.getResourceDetailByIdFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.setResourceState, (state) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.setResourceStateSuccess, (state, { resourceId, state: resourceState }) => {
    const isCurrentResource = state.page.resource.detail?.resourceId === resourceId;

    return {
      ...state,
      page: {
        ...state.page,
        resource: {
          ...state.page.resource,
          detail: isCurrentResource ? {
            ...state.page.resource.detail,
            currentState: resourceState,
          } : state.page.resource.detail,
          isLoading: false,
        },
      },
    };
  }),
  on(TechInventoryActions.setResourceStateFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.setResourceLocation, (state) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        isLoading: true,
      },
    },
  })),
  on(TechInventoryActions.setResourceLocationSuccess, (state, { resourceId, location }) => {
    const isCurrentResource = state.page.resource.detail?.resourceId === resourceId;

    return {
      ...state,
      page: {
        ...state.page,
        resource: {
          ...state.page.resource,
          detail: isCurrentResource ? {
            ...state.page.resource.detail,
            location,
          } : state.page.resource.detail,
          isLoading: false,
        },
      },
    };
  }),
  on(TechInventoryActions.setResourceLocationFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        isLoading: false,
      },
    },
  })),
  on(TechInventoryActions.getResourceDetailByIdMissionsPaginated, (state) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        missions: {
          ...state.page.resource.missions,
          isLoading: true,
        },
      },
    },
  })),
  on(TechInventoryActions.getResourceDetailByIdMissionsPaginatedCancel, (state) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        missions: {
          ...state.page.resource.missions,
          isLoading: false,
        },
      },
    },
  })),
  on(TechInventoryActions.getResourceDetailByIdMissionsPaginatedRefresh, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        missions: {
          ...state.page.resource.missions,
          items: [...data.items],
          paging: data.paging,
          isLoading: false,
        },
      },
    },
  })),
  on(TechInventoryActions.getResourceDetailByIdMissionsPaginatedSuccess, (state, { data }) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        missions: {
          ...state.page.resource.missions,
          // Important! include the current state.items and the data.items to create a new array with the
          // existing ones and the new one that is requested
          items: [...state.page.mission.items, ...data.items],
          paging: data.paging,
          isLoading: false,
        },
      },
    },
  })),
  on(TechInventoryActions.getResourceDetailByIdMissionsPaginatedFail, (state) => ({
    ...state,
    page: {
      ...state.page,
      resource: {
        ...state.page.resource,
        missions: {
          ...state.page.resource.missions,
          isLoading: false,
        },
      },
    },
  })),
  on(TechInventoryActions.reportGoogleAPILoaded, (state) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        isGoogleAPILoaded: true,
      },
    },
  })),
  on(TechInventoryActions.getArticleRestrictionsSuccess, (state, { restrictions }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        report: {
          ...state.page.mission.report,
          articleRestrictions: restrictions,
        },
      },
    },
  })),
  on(TechInventoryActions.keepLastScrollTopPosition, (state, { scrollTop }) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        lastScrollTop: scrollTop
      },
    },
  })),
  on(TechInventoryActions.keepTodayViewState, (state, {date, scrollTop}) => ({
    ...state,
    page: {
      ...state.page,
      mission: {
        ...state.page.mission,
        todayDate: date ?? state.page.mission.todayDate,
        todayScrollTop: scrollTop ?? state.page.mission.todayScrollTop
      }
    }
  })),
);
